import { Injectable, Inject } from '@angular/core';
import { ApiConfig } from 'base-api-service';
import { CommonUtil } from 'base-api-service';
import { CookieIdentifiers } from '../constants/cookie.identifiers';
import { SkypAuthService } from './skyp-auth.service';
// import { environment } from '../../../environments/environment';

export class AuthHelper {
    constructor(  private apiConfig: ApiConfig) { }

    /**
    * Determine if there is a user correctly logued in the app
    */
    isUserLogged(): boolean {
        if (this.apiConfig.authService.name === 'SkypAuthService') {
            return true;
        }
        const userId = this.getUserLogged();
        const token = this.getToken();
        return (!CommonUtil.isEmpty(userId) && !CommonUtil.isEmpty(token));
    }

    /**
     * Returns the name of the user logged in the app
     */
    getUserLogged(): string | null {
        if (this.apiConfig.authService.name === 'SkypAuthService') {
            return null;
        }
        return CommonUtil.getCookie(CookieIdentifiers.USER_ID);
    }

    /**
     * Returns the token stored after login
     */
    getToken(): string | null {
        if (this.apiConfig.authService.name === 'SkypAuthService') {
            return null;
        }
        return CommonUtil.getCookie(CookieIdentifiers.TOKEN_ID);
    }

    /**
   * Add user id to the cookie
   * @param value the value of the user id
   * @param expiredTime the total seconds after the page should expire
   */
    addUserInfo(value: string, expiredTime: number) {
        const expiredTimeString = CommonUtil.changeExpiredTime(expiredTime * 60 * 1000);
        document.cookie = CookieIdentifiers.USER_ID + '=' + value + '; expires=' + expiredTimeString + '; path=/';
    }

    /**
     * Add token to the cookie
     * @param value the value of the token
     * @param expiredTime the total seconds after the page should expire
     */
    addTokenInfo(value: string, expiredTime: number) {
        const expiredTimeString = CommonUtil.changeExpiredTime(expiredTime * 60 * 1000);
        document.cookie = CookieIdentifiers.TOKEN_ID + '=' + value + '; expires=' + expiredTimeString + '; path=/';
    }

    /**
     * Remove the user id from the cookie
     */
    removeUserInfo() {
        const expiredTimeString = CommonUtil.changeExpiredTime(0);
        document.cookie = CookieIdentifiers.USER_ID + '=; expires=' + expiredTimeString + '; path=/';
    }

    /**
     * Remove the token from the cookie
     */
    removeTokenInfo() {
        const expiredTimeString = CommonUtil.changeExpiredTime(0);
        document.cookie = CookieIdentifiers.TOKEN_ID + '=; expires=' + expiredTimeString + '; path=/';
    }
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiConfig, decorators: [{ type: Inject, args: ['api.config', ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
